module.exports = __webpack_public_path__ + "static/img/manual-21.631a887.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-21.png
// module id = Q/yt
// module chunks = 4